import React, { ReactElement, ReactNode, useState } from 'react';
import { Icon, Text, Theme } from '@feast-it/ui/light';
import { useTheme } from 'emotion-theming';

import { useBreakpoint } from '../../../hooks/media';
import * as Styled from './Item.styled';

interface ItemProps {
  children: ReactNode;
  heading: string;
  headingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  // eslint-disable-next-line no-unused-vars
  onToggle?: (expanded: boolean) => void;
  defaultExpanded?: boolean;
  interactive?: boolean;
}

export function Item(props: ItemProps): ReactElement {
  const [isExpanded, setIsExpanded] = useState(props.defaultExpanded || false);
  const theme: Theme = useTheme();
  const isSmallBreakpoint = useBreakpoint(theme.breakpoints.small);
  const handleHeaderOnClick = () => {
    const next = !isExpanded;
    setIsExpanded(next);
    props.onToggle?.(next);
  };

  return (
    <Styled.Container>
      <Styled.Header
        interactive={props.interactive}
        onClick={props.interactive ? handleHeaderOnClick : undefined}
      >
        <Text
          as="h3"
          style={isSmallBreakpoint ? 'headingSmall' : 'headingMobileSmall'}
        >
          {props.heading}
        </Text>

        {props.interactive && (
          <Icon
            fill="black"
            name={isExpanded ? 'ArrowUpSmall' : 'ArrowDownSmall'}
            size={24}
          />
        )}
      </Styled.Header>

      {isExpanded && <Styled.Body>{props.children}</Styled.Body>}
    </Styled.Container>
  );
}
